import React, { useState } from 'react';

import style from './index.module.scss';

interface IItem {
  icon: string;
  activeIcon: string;
  text: string;
  children?: React.ReactNode;
  onClick?: () => void;
}
export default ({ icon, text, children, activeIcon, onClick }: IItem) => {
  const [image, setImage] = useState(icon);
  function handlerMouseEnter() {
    setImage(activeIcon);
  }
  function handlerMouseLeave() {
    setImage(icon);
  }
  return (
    <div
      className={style.container}
      onMouseEnter={handlerMouseEnter}
      onMouseLeave={handlerMouseLeave}
      onClick={onClick}
    >
      <div className={style.icon}>
        <img src={image} alt="" />
      </div>
      <div className={style.text}>{text}</div>
      <div className={style.hover}>{children}</div>
    </div>
  );
};
